var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.1254 12.8159L18.0625 16.753C18.4241 17.1145 18.4241 17.7007 18.0625 18.0622C17.8815 18.2433 17.6449 18.3335 17.4078 18.3335C17.1708 18.3335 16.9342 18.2433 16.7532 18.0622L12.8161 14.1252C11.6476 15.0187 10.193 15.5557 8.61149 15.5557C4.78229 15.5557 1.66699 12.4404 1.66699 8.61124C1.66699 4.78205 4.78229 1.66675 8.61149 1.66675C12.4407 1.66675 15.556 4.78205 15.556 8.61124C15.556 10.1927 15.0189 11.6474 14.1254 12.8159ZM3.51887 8.61125C3.51887 11.4191 5.80361 13.7039 8.6115 13.7039C11.4194 13.7039 13.7041 11.4191 13.7041 8.61125C13.7041 5.80336 11.4194 3.51862 8.6115 3.51862C5.80361 3.51862 3.51887 5.80336 3.51887 8.61125Z","fill":"black"}));
}

SearchInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
